export default class Config {
    parameters = {
        prompt: "",
        steps: 0,
        seed: 0,
        num: 0,
        sampling_method: "LMS",
        seedList: ["", "", "", ""],
        imageDialog: null,
        regenerate: false,
        image64: "",
        maskImage64: "",
        inpaint_mask_blur: "4",
        inpaint_mask_content: "latent noise",
        mode: "txt2img",
        strength: "1"
    }



    generalConfig = {    
        url: "",
        tokenid: "",
        token: "",
        name: "local",
        type: "Colab",
        inpaint_mask_blur: "4",
        inpaint_mask_content: "latent noise",
        width: '1024',
        height: '1024',
        m1fix: false,
        allVisible:true,
        dlgData: {
            "mode": "txt2img",
            "prompt": "",
            "seed": "",
            "steps": "15",
            "steps_update": "50",
            "num": "2",
            "modifiers": "highly detailed",
            "cfg_value": "7.5",
            "strength": ".75",
            "sampling_method": "LMS",
            "previewMode": ""
        }
    }
    globalData={
        prompt:"",
        modifiers:"",
        appRegisteredhash:"",
        dateRegistered:"",
        fingerprint:""
    }
    ModifierData = {
        list: [],
        tags: []
    }
    configList = []
    currentConfigNum = 0


    getDefault(type) {
        let SDConfig
        let parameters
        if (type === "SDGRPC") {
            SDConfig = {
                url: "",
                tokenid: "",
                token:"",
                name: "Gyre",
                type: "SDGRPC",
                width: '1024',
                height: '1024',
                m1fix: false,
                allVisible:true,
                dlgData: {
                    "mode": "txt2img",
                    "prompt": "",
                    "seed": "",
                    "steps": "15",
                    "steps_update": "20",
                    "num": "2",
                    "modifiers": "highly detailed",
                    "cfg_value": "7.5",
                    "strength": ".75",
                    "sampling_method": "DPMSolver++ 2M (Fast)"
                }
            }
            parameters = {
                prompt: "",
                steps: 0,
                seed: 0,
                num: 0,
                sampling_method: "LMS",
                seedList: ["", "", "", ""],
                imageDialog: null,
                regenerate: false,
                image64: "",
                maskImage64: "",
                inpaint_mask_blur: "4",
                inpaint_mask_content: "latent noise",
                mode: "txt2img",
                strength: "1"
            }
            return { generalConfig: SDConfig, parameters: parameters }
        }        

    }
    constructor() {
    //    this.load()
    }
    async saveToken(tokenid,token) {
        if (!token) token="";
        window.localStorage.setItem(tokenid, token);
    }

    async loadToken(tokenid) {
        if (!tokenid) return;

        let result = window.localStorage.getItem(tokenid);
        return result || "";
    }
    async updateGlobalData(globalData) {
        await this.load()
        this.globalData=globalData
        await this.save()
    }

    async save() {
        let configListClone =  JSON.parse( JSON.stringify(this.configList));
//        configListClone.forEach((el)=>{   
  //          el.generalConfig.token = "";
    //    })

        let saveObj = { configList: configListClone, currentConfigNum: this.currentConfigNum, ModifierData: this.ModifierData,globalData: this.globalData }
        let all = JSON.stringify(saveObj)
        await window.localStorage.setItem("config", all)
    }
    async load() {

        let allconfStr = await localStorage.getItem("config")
        if (!allconfStr) console.log("no config")
        if (allconfStr) {
            let allconf = JSON.parse(allconfStr)
            this.configList = allconf.configList
            if (allconf.ModifierData) this.ModifierData = allconf.ModifierData
            if (allconf.globalData) this.globalData = allconf.globalData
            this.currentConfigNum = allconf.currentConfigNum

            await this.get()

        }
        return null  
    }
    async add(configType) {
        let d = this.getDefault(configType)
        this.configList.push(d)
        this.currentConfigNum = this.configList.length - 1
        await this.get()
        await this.save()
    }
    async switch(num) {
        await this.load()
        this.currentConfigNum = num
        await this.save()
        await this.get()
        return this
    }



    async set() {
        let obj = JSON.parse( JSON.stringify({ generalConfig: this.generalConfig, parameters: this.parameters }))
        if (!obj.generalConfig.tokenid){
            this.generalConfig.tokenid =  obj.generalConfig.tokenid =  (Math.random() + 1).toString(36).substring(2);
        }
        if (this.generalConfig.tokenid && this.generalConfig.tokenid.length) {
            try {
               await this.saveToken(this.generalConfig.tokenid,this.generalConfig.token)
            } catch (e) {
            }
        }               
        this.configList[this.currentConfigNum] = obj
      //  console.log(this.configList,this.generalConfig)
        if (this.generalConfig.dlgData) {
            this.globalData.prompt=this.generalConfig.dlgData.prompt
            this.globalData.modifiers=this.generalConfig.dlgData.modifiers
        }
        await this.save()
    }
    async get() {
        let conf = this.configList[this.currentConfigNum]
        if (!conf) return

        this.generalConfig = conf.generalConfig
        if (this.generalConfig.tokenid && this.generalConfig.tokenid.length) {
            try {
                this.generalConfig.token = await this.loadToken(this.generalConfig.tokenid)
            } catch (e) {
            }
        }
        if (this.generalConfig.dlgData && this.globalData && this.globalData.prompt) {
            this.generalConfig.dlgData.prompt=this.globalData.prompt
            this.generalConfig.dlgData.modifiers=this.globalData.modifiers
        }
        this.parameters = conf.parameters        
    }
    async delete() {
        this.configList.splice(this.currentConfigNum,1)
        this.currentConfigNum=0
     //   console.log(this.configList)
        await this.get()
        await this.save()
    }
}